import { Heart, Phone, Mail, Landmark, Smartphone } from "lucide-react";
import { FadeIn } from "../components/FadeIn";
import { PageHeader } from "../components/PageHeader";
import { Section, Overline, AmfButton, Divider } from "../components/Primitives";
import { IMAGES, CONTACT } from "../data/content";
import { useContent } from "../context/ContentContext";

const AMOUNTS = ["GH₵ 50", "GH₵ 150", "GH₵ 500", "Custom"];

export default function Donate() {
  const { t } = useContent();
  return (
    <div data-testid="donate-page">
      <PageHeader
        eyebrow={t("donate.header.eyebrow")}
        title={t("donate.header.title")}
        intro={t("donate.header.intro")}
        image={IMAGES.schoolgirlWhite}
      />

      <Section className="bg-amf-cream">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <FadeIn className="lg:col-span-7">
            <Overline>Make a Gift</Overline>
            <h2 className="font-playfair text-3xl md:text-4xl text-amf-navy mt-3">
              {t("donate.main.heading")}
            </h2>
            <p className="font-lora text-lg text-amf-charcoal/85 mt-5 leading-relaxed">
              {t("donate.main.text")}
            </p>

            <div className="grid grid-cols-2 sm:grid-cols-4 gap-px bg-amf-gold/30 border border-amf-gold/30 mt-8">
              {AMOUNTS.map((a) => (
                <div
                  key={a}
                  className="bg-amf-cream py-6 text-center font-playfair text-xl text-amf-navy"
                >
                  {a}
                </div>
              ))}
            </div>

            <div className="mt-8">
              <AmfButton
                data-testid="donate-now-button"
                onClick={() =>
                  alert(
                    "Online giving coming soon. Please use the bank or Mobile Money details provided.",
                  )
                }
              >
                <Heart size={16} className="mr-2" /> Donate Now
              </AmfButton>
              <p className="amf-overline text-amf-stone mt-4">
                Online giving coming soon — Stripe / PayPal / Mobile Money
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.12} className="lg:col-span-5">
            <div className="bg-amf-navy text-amf-cream p-9 md:p-10">
              <Overline light>Ways to Give</Overline>
              <div className="mt-6 space-y-5">
                <div className="flex gap-4">
                  <Landmark size={20} strokeWidth={1.5} className="text-amf-gold shrink-0 mt-1" />
                  <div>
                    <p className="font-inter text-sm text-amf-cream/90">Bank Transfer</p>
                    <p className="font-lora text-amf-cream/70 text-sm mt-1">
                      Account details available on request — please contact us.
                    </p>
                  </div>
                </div>
                <div className="flex gap-4">
                  <Smartphone size={20} strokeWidth={1.5} className="text-amf-gold shrink-0 mt-1" />
                  <div>
                    <p className="font-inter text-sm text-amf-cream/90">Mobile Money</p>
                    <p className="font-lora text-amf-cream/70 text-sm mt-1">
                      MoMo giving line forthcoming.
                    </p>
                  </div>
                </div>
              </div>
              <Divider className="my-7 opacity-20" />
              <ul className="space-y-4">
                <li className="flex gap-3 items-center">
                  <Phone size={18} className="text-amf-gold" />
                  <span className="font-lora text-amf-cream/90 text-sm">{CONTACT.phone}</span>
                </li>
                <li className="flex gap-3 items-center">
                  <Mail size={18} className="text-amf-gold" />
                  <a href={`mailto:${CONTACT.email}`} className="font-lora text-amf-cream/90 text-sm hover:text-amf-gold break-all">
                    {CONTACT.email}
                  </a>
                </li>
              </ul>
            </div>
          </FadeIn>
        </div>
      </Section>
    </div>
  );
}
